// Appended after the effect file
void main()
{
    vUv = uv;
    float elevation = 0.0;
    vec3 pos = displace(position, uv, elevation);
    vElevation = elevation;

    vec4 mvPosition = modelViewMatrix * vec4(pos, 1.0);
    gl_Position = projectionMatrix * mvPosition;

    // Only used when rendered as THREE.Points; shrinks with distance
    gl_PointSize = uPointSize * uPixelRatio / -mvPosition.z;
}
